import { NetworkService } from '@/services/NetworkService'

interface IModel {
  id: string
  name: string
  year: number
}

export class Model implements IModel {
  id!: string
  name!: string
  year!: number

  constructor(params: IModel) {
    Object.assign(this, params)
  }

  public static async getModels(makeId: string = '', yearId: number = -1): Promise<Model[]> {
    let res = await NetworkService.get(
      process.env.VUE_APP_API_BASE_URL +
      '/api/v1/models' + (yearId != -1 && makeId ? ('?makeId=' + makeId + '&yearId=' + yearId) : '')
    )

    let models : Model[] = []

    res.data.data.forEach( (m: any) => {
      let model : Model = new Model(m)
      models.push(model)
    })

    return models
  }
  public static async getCarouselModels(makeId: string): Promise<Model[]> {
    let res = await NetworkService.get(
      process.env.VUE_APP_API_BASE_URL +
      '/api/v1/models/carousel' + "?makeId=" + makeId
    )

    let models: Model[] = []

    res.data.data.forEach((m: any) => {
      let model: Model = new Model(m)
      models.push(model)
    })

    return models
  }
}
